function checkAndUpdateAccordion() {
  const ksChartContainer = document.querySelector('.ks-chart-container');
  if (ksChartContainer) {
    var productFormHTML = ksChartContainer.outerHTML;
    const accordions = document.querySelectorAll('.product__accordion');
    accordions.forEach(accordion => {
      const accordionTitle = accordion.querySelector('.accordion__title');
      if (accordionTitle.textContent.trim() === 'Size & Fit') {
        const accordionContent = accordion.querySelector('.accordion__content');
        accordionContent.innerHTML = accordionContent.innerHTML + productFormHTML;
      }
    });
    clearInterval(intervalId);
  }
}
const intervalId = setInterval(checkAndUpdateAccordion, 500);
